export default __webpack_public_path__ + "static/media/img_cotizador_medicamentos.cc192e27.svg";